import { render } from "./barreRisultato.vue?vue&type=template&id=e50f430e&ts=true"
import script from "./barreRisultato.vue?vue&type=script&lang=ts"
export * from "./barreRisultato.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\CarpeDiem\\AntiSmoking\\Backend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__